import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { TranslocoModule } from '@ngneat/transloco';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { ZuiMaterialStackModule } from '@zerops/zui/material-stack';
import { UserDataEditFormModule } from '@zerops/zui/user-data-edit-form';
import { FormSectionModule } from '@zerops/zui/form-section';
import { UserDataFieldsModule } from '@zerops/zui/user-data-fields';
import { ProjectEnvsEditDialogFeature } from './project-envs-edit-dialog.feature';
import { ProjectEnvsEditDialogEffect } from './project-envs-edit-dialog.effect';
import { ProjectEnvsEditFormComponent } from './components';
import { ProjectEnvsEditDialogTranslationsModule } from './project-envs-edit-dialog.translations';

@NgModule({
  declarations: [ ProjectEnvsEditDialogFeature ],
  imports: [
    CommonModule,
    ZuiMaterialStackModule,
    UserDataEditFormModule,
    EffectsModule.forFeature([ ProjectEnvsEditDialogEffect ]),
    FormSectionModule,
    ReactiveFormsModule,
    ZefProgressErrorModule,
    TranslocoModule,
    ProjectEnvsEditDialogTranslationsModule,
    UserDataFieldsModule,
    ZefDialogModule,
    ZefScrollbarComponent,
    ProjectEnvsEditFormComponent
  ],
  exports: [ ProjectEnvsEditDialogFeature ]
})
export class ProjectEnvsEditDialogModule {}
